import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import {
  LoadingSpinner,
  useAuthUser,
  useCurrentCompany,
} from '@employ-engage/common-components';

/* eslint-disable-next-line */
export interface RedirectToUserMainDashboardProps {}

export function RedirectToUserMainDashboard(
  props: RedirectToUserMainDashboardProps
) {
  const navigate = useNavigate();
  const { user } = useAuthUser();
  const { currentCompany } = useCurrentCompany();

  useEffect(() => {
    if (user) {
      navigate(`/${currentCompany.friendlyCompanyId}/admin/dashboard`);
    } else {
      navigate('/');
    }
  }, [navigate, user]);

  return <LoadingSpinner spinnerId="redirect-to-user-main-dashboard-loading" />;
}

export default RedirectToUserMainDashboard;
